import { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { DEFAULT_GAS_CHANNEL } from '../../../../constants';
export var useAnalytics = function useAnalytics() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var fireAnalyticsEvent = useCallback(function (payload) {
    createAnalyticsEvent(payload).fire(DEFAULT_GAS_CHANNEL);
  }, [createAnalyticsEvent]);
  return [fireAnalyticsEvent];
};